module.exports = __webpack_public_path__ + "static/media/big.474427a2.png";